import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchPortalMessages } from '../../utilities/dashboardServices'
import { toast } from 'react-toastify'

export const fetchMessages = createAsyncThunk(
    'users/fetchPortalMessages', fetchPortalMessages
)

const initialState = {
    loginPortalMessage:[],
    dashboardPortalMessage:[],
    isLoginPortalMessage: false,
    isDashboardPortalMessage: false,
}

const portalMessagesSlice = createSlice({
    name: 'applications',
    initialState,
    reducers: {
        resetPortalMessages: (state) => {
            // toast.success("PortalMessages reseted Successfully")
            state.loginPortalMessage = [];
            state.dashboardPortalMessage = [];
            state.isLoginPortalMessage = false;
            state.isDashboardPortalMessage = false;
        },
        setIsPortalMessage:(state,action) =>{
            if(action.payload == 'login'){
                state.isLoginPortalMessage = false;
            }else{
                state.isDashboardPortalMessage = action.payload;
            }
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchMessages.pending, (state, action) => {
            })
            .addCase(fetchMessages.fulfilled, (state, action) => {
                let response =  action.payload.faf
                let arrlogin = []
                let arrDashboard = []
                response.length > 0 && response.map((data) => {
                    if ((typeof data?.Portals != 'undefined' && data.Status == 'Active' || data.Status == 'Yes') ) {
                     if(data.Type == "Login" ){             
                         data.Portals.map((msgI)=>{
                             if(msgI.PortalName=="Partner" && msgI.CanDisplayMessage == 'true'){
                                 arrlogin.push(data.message);
                             }
                        })
                     }else if(data.Type == "UserDashboard"){                        
                         data.Portals.map((msgI)=>{
                             if(msgI.PortalName=="Partner" && msgI.CanDisplayMessage == 'true'){
                                 arrDashboard.push(data.message);
                             }
                        })
                     }else{
                         data.Portals.map((msgI)=>{
                             if(msgI.PortalName=="Partner" && msgI.CanDisplayMessage == 'true'){
                                 arrlogin.push(data.message);
                                 arrDashboard.push(data.message);
                             }
                        })               
                      }
                         }
                     })

                let response2 = action.payload.cpr
                response2.length > 0 && response2.map((data) => {
                    if ((typeof data?.Portals != 'undefined' && data.Status == 'Active' || data.Status == 'Yes') ) {
                     if(data.Type == "Login" ){             
                         data.Portals.map((msgI)=>{
                             if(msgI.PortalName=="Partner" && msgI.CanDisplayMessage == 'true'){
                                 arrlogin.push(data.message);
                             }
                        })
                     }else if(data.Type == "UserDashboard"){                        
                         data.Portals.map((msgI)=>{
                             if(msgI.PortalName=="Partner" && msgI.CanDisplayMessage == 'true'){
                                 arrDashboard.push(data.message);
                             }
                        })
                     }else{
                         data.Portals.map((msgI)=>{
                             if(msgI.PortalName=="Partner" && msgI.CanDisplayMessage == 'true'){
                                 arrlogin.push(data.message);
                                 arrDashboard.push(data.message);
                             }
                        })               
                      }
                         }
                     })

                // login page message update
                if(arrlogin.length > 0){
                    state.loginPortalMessage = arrlogin.filter((item, index) => arrlogin.indexOf(item) === index); 
                    state.isLoginPortalMessage = true;
                }else{
                    state.isLoginPortalMessage = false;

                }

                // Dashboard page message update
                if(arrDashboard.length > 0){
                    state.dashboardPortalMessage = arrDashboard.filter((item, index) => arrDashboard.indexOf(item) === index);
                    state.isDashboardPortalMessage = true;
                }else{
                    state.isDashboardPortalMessage = false;

                }

                // toast.success("Portal Messages Fetched Successfully")
            })
            .addCase(fetchMessages.rejected, (state, action) => {
                toast.error(action.error.message)
            })
    },
})

export const { resetPortalMessages, setIsPortalMessage } = portalMessagesSlice.actions

export const portalMessages = state => state.portalMessagesSlice.value
export default portalMessagesSlice.reducer